import { Fragment } from 'react'
import { createCountText, createGuid } from '../../../map_utils/index'
import AccordionSection from './AccordionSection'
import { AccordionType } from '../../../interfaces/index'

const Accordion = ({ id, content, setLocation, setIsOpen, scrollToMap }: AccordionType) => {
  return (
    <div
      aria-label="Accordion Control Group Buttons"
      id={id}
      className="wc-outages__accordion"
    >
      {content.map((d, i) => {
        const {
          suburb,
          isOpen,
          completedCount,
          upcomingCount,
          outageCount,
          majorCount,
          outages
        } = d
        const fn = setIsOpen(suburb)
        return (
          <Fragment key={createGuid()}>
            <AccordionSection
              index={i}
              id={createGuid()}
              label={suburb}
              scrollToMap={scrollToMap}
              count={createCountText({
                completedCount: completedCount as number,
                upcomingCount: upcomingCount as number,
                outageCount: outageCount as number,
                majorCount: majorCount as number
              })}
              content={outages}
              isOpen={isOpen}
              setIsOpen={fn}
              setLocation={setLocation}
            />
          </Fragment>
        )
      })}
    </div>
  )
}

export default Accordion
